import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import CardPaymentPopup from './CardPaymentPopup';

export default withRouter(injectIntl(CardPaymentPopup));
